import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoPergunta02Model } from './model-consultaSeguimentoPergunta02'

export function isPergunta02IgnoraAllNao(value: ConsultaSeguimentoPergunta02Model['PERGUNTA_02_IGNORA']): boolean {
  return value?.IGNORA_PESSOAS === SimNaoEnum.NAO && value?.IGNORA_SONS === SimNaoEnum.NAO
}

export function hasPergunta02IgnoraAnySim(value: ConsultaSeguimentoPergunta02Model['PERGUNTA_02_IGNORA']): boolean {
  return value?.IGNORA_PESSOAS === SimNaoEnum.SIM || value?.IGNORA_SONS === SimNaoEnum.SIM
}

export function prunePergunta02(value: ConsultaSeguimentoPergunta02Model): ConsultaSeguimentoPergunta02Model {
  const pruned: ConsultaSeguimentoPergunta02Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_02_IGNORA: value.PERGUNTA_02_IGNORA,
    PERGUNTA_02_FEZ_EXAME: value.PERGUNTA_02_FEZ_EXAME,
  }

  if (value.PERGUNTA_02_FEZ_EXAME === SimNaoEnum.SIM) {
    pruned.PERGUNTA_02_RESULTADO_EXAME = value.PERGUNTA_02_RESULTADO_EXAME
  }

  return pruned
}
